import { DatePipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { GotoBlocklyDirective } from 'src/app/shared/directives/goto-blockly.directive';
import { PlaceholderInfoDirective } from 'src/app/shared/directives/placeholder-info.directive';
import { customCode } from 'src/app/shared/services/codecompletion.service';
import { EditorItemsService } from 'src/app/shared/services/editor-items.service';
import { FusionService } from '@shared-angular/services/fusion.service';
import { getFusionBotTypeOptions } from '../fusionbot-tab.utils';
import { LanguageService } from '@shared-angular/services/language.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';
import { CodemirrorHtmlComponent } from '../../../../../../../../shared/components/ai-bot/utils/codemirror-html/codemirror-html.component';
import { ToastrService } from '@shared-angular/services/toastr.service';



@Component({
  selector: 'app-fusion-storyline-config',
  imports: [DatePipe, DecimalPipe,
    FormsModule,
    GotoBlocklyDirective,
    PlaceholderInfoDirective,
    CodemirrorHtmlComponent,
    ButtonModule,
    InputTextModule,
    SelectModule,
    ProgressBarModule,
    ToggleSwitchModule,
    RadioButtonModule,
    SelectButtonModule,
    TooltipModule
  ],
  templateUrl: './fusion-storyline-config.component.html',
  styleUrl: './fusion-storyline-config.component.scss'
})
export class FusionStorylineConfigComponent {
  public showHtmlEditor = false;

  protected get botTypeOptions() {
    return getFusionBotTypeOptions(this.fusionService.loginService.systemConf);
  }
  protected systemLanguageOptions = [
    { label: $localize`:@@fusionconfig-systemlang-de:Deutsch`, value: 'de' },
    { label: $localize`:@@fusionconfig-systemlang-en:Englisch`, value: 'en' },
    { label: $localize`:@@fusionconfig-systemlang-fr:Französisch`, value: 'fr' },
    { label: $localize`:@@fusionconfig-systemlang-es:Spanisch`, value: 'es' },
    { label: $localize`:@@fusionconfig-systemlang-it:Italienisch`, value: 'it' },
    { label: $localize`:@@fusionconfig-systemlang-nl:Niederländisch`, value: 'nl' },
    { label: $localize`:@@fusionconfig-systemlang-nb:Norwegisch`, value: 'nb-no' },
    { label: $localize`:@@fusionconfig-systemlang-fr-be:Französisch (Belgien)`, value: 'fr-be' },
    { label: $localize`:@@fusionconfig-systemlang-nl-be:Niederländisch (Belgien)`, value: 'nl-be' },
    { label: $localize`:@@fusionconfig-systemlang-pl:Polnisch`, value: 'pl' },
    { label: $localize`:@@fusionconfig-systemlang-pt:Portugiesisch`, value: 'pt' },
    { label: $localize`:@@fusionconfig-systemlang-hu:Ungarisch`, value: 'hu' },
    { label: $localize`:@@fusionconfig-systemlang-ro:Rumänisch`, value: 'ro' },
    { label: $localize`:@@fusionconfig-systemlang-tr:Türkisch`, value: 'tr' },
    { label: $localize`:@@fusionconfig-systemlang-fi:Finnisch`, value: 'fi' },
    { label: $localize`:@@fusionconfig-systemlang-sv:Schwedisch`, value: 'sv' },
    { label: $localize`:@@fusionconfig-systemlang-da:Dänisch`, value: 'da' },
    { label: $localize`:@@fusionconfig-systemlang-cs:Tschechisch`, value: 'cs' },
    { label: $localize`:@@fusionconfig-systemlang-el:Griechisch`, value: 'el' }
  ];
  protected viewModeOptions = [
    { label: $localize`:@@fusionconfig-viewmode-split:Split (Side-by-Side)`, value: 'split' },
    { label: $localize`:@@fusionconfig-viewmode-split-reverse:Split Reverse (Side-by-Side)`, value: 'split-reverse' },
    { label: $localize`:@@fusionconfig-viewmode-window:Fenster (Overlay)`, value: 'window' },
    { label: $localize`:@@fusionconfig-viewmode-full:Vollbild`, value: 'full' },
    { label: $localize`:@@fusionconfig-viewmode-float:Floating (Chat-Bubble)`, value: 'float' }
  ];


  constructor(
    protected rss: RouteShareService,
    public fusionService: FusionService,
    public langService: LanguageService,
    protected stageAdmin: StageAdminService,
    private toastr: ToastrService,
    protected editorItemService: EditorItemsService
  ) { }

  public async uploadFile(event: Event) {
    const element = event.target as HTMLInputElement;
    if (element.files?.[0] != null && this.fusionService.selectedStoryline) {
      await this.fusionService.upload(element.files[0], this.fusionService.selectedStoryline._id, this.rss.botConfig._id);
    }
  }

  public async addURL(url: string) {
    const result = await this.fusionService.embedInfo(url);
    if (result.status != "ok") {
      this.toastr.error("ERROR_400", ($localize`:@@invalid-domain:URL ist ungültig`));
      return;
    }

    await this.fusionService.updateFusionField('proxyUrl', url);
    await this.fusionService.updateFusionField('useStaticHtml', false);
  }

  protected setCustomCompletions(): customCode[] {
    const customCode: customCode[] = [];
    return customCode;
  }
}
